export default "__VITE_ASSET__C6it9o6E__"